import { EmailProfileMessageBodyAttachedFilesSkeleton } from '../EmailProfileMessageBodyAttachedFilesSkeleton'
import { EmailProfileMessageBodySkeleton } from '../EmailProfileMessageBodySkeleton'
import { EmailProfileMessageHeaderSkeleton } from '../EmailProfileMessageHeader'

import * as styles from './EmailProfileMessageSkeleton.module.css'

function EmailProfileMessageSkeleton() {
  return (
    <div className={styles.EmailProfileMessageSkeleton}>
      <EmailProfileMessageHeaderSkeleton />

      <EmailProfileMessageBodySkeleton />

      <EmailProfileMessageBodyAttachedFilesSkeleton />
    </div>
  )
}

export default EmailProfileMessageSkeleton
